import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';

import type { LinkProps } from '@mui/material/Link';
import Link from '@mui/material/Link';

import AtpSkeleton from './skeleton';

interface IProps extends LinkProps {
  preload?: boolean;
  width?: number | string;
  height?: number | string;
}

type refType = HTMLAnchorElement | null;

const TempLink = ({ preload = false, width, height, ...rest }: IProps, ref: ForwardedRef<refType>) => {
  return preload ? <AtpSkeleton width={width} height={height} variant="rectangular" /> : <Link ref={ref} {...rest} />;
};

const AtpLink = forwardRef<refType, IProps>(TempLink);
export default AtpLink;
